import { ExclamationCircleOutlined } from '@ant-design/icons'
import Api from '@api/coupon'
import {
  COLLECTION_STORE,
  ONLY_MEMBER
} from '@components/LocalMerchant/Coupons/constant'
import { COUPONS_PATH_A } from '@constant'
import { getMomentTime } from '@hlj/hlj-utils'
import BaseStore from '@store/table'
import { message, Modal } from 'hljd'
import { observable } from 'mobx'
import React from 'react'

class Store extends BaseStore {
  @observable show = false
  @observable more = false

  $extraOp = (data, page) => {
    const { list } = data
    if (list.length > 0) {
      this.show = true
      this.more = true
    } else {
      this.show = true
    }
  }

  $listApi = Api.getList
  $pageSize = 10
  $ignoreParams = ['date']
  $getParams = () => {
    const { date, ...rest } = this.$params
    return {
      ...rest,
      start_time: date && getMomentTime(date, 0) + ' 00:00:00',
      end_time: date && getMomentTime(date, 1) + ' 23:59:59'
    }
  }

  /**
   *  跳转优惠券编辑页
   *  open 如果为 true 表示打开新页面（如装修中的优惠券编辑）
   */
  toEdit = (id, open) => () => {
    let url = id ? `${COUPONS_PATH_A}/detail/${id}` : `${COUPONS_PATH_A}/detail`

    if (open) {
      url += '?from=decoration'
      window.open(url)
    } else {
      window.location.href = url
    }
  }

  checkStatus = (id, condition_of_get, property, hidden) => () => {
    if (
      property &&
      (condition_of_get == COLLECTION_STORE ||
        condition_of_get == ONLY_MEMBER) &&
      hidden == 0
    ) {
      Modal.confirm({
        title: '开启后，所有用户均可领取该优惠券',
        icon: <ExclamationCircleOutlined />,
        content: '你还要继续吗？',
        onOk: () => {
          this.invalid(id)()
        }
      })
    } else {
      this.invalid(id)()
    }
  }

  invalid = id => async () => {
    console.log('id: ', id)
    const { success } = await Api.activation({ id })

    if (success) {
      message.success('操作成功')
      this.$getList()
    }
  }
}

export default Store
